// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"6e8216ee","389":"eb5cc2c6","455":"a5e27d42","977":"298b0868"}[chunkId] + ".chunk.js";
};